<div class="row mt-3 p-2">
    <div class="col bg-white rounded shadow-sm border border-black pt-2">
        Escolha os clientes a fazerem parte desse grupo:
        <div class="mt-2">
            <input class="input form-control form-control-sm" [(ngModel)]="filtrar" type="text"
                placeholder="Pesquise pelo nome do cliente" (ngModelChange)="filtrarUsuario()">
        </div>
        <ng-container *ngIf="clientesTabela.length == 0">
            <p>Os usuários não possuem clientes em comum</p>
        </ng-container>
        <table class="table">
            <thead>
                <tr>
                    <th>nome</th>
                </tr>
            </thead>
            <tbody>
                <tr class="hover"
                    *ngFor="let cliente of clientesTabela| paginate: {itemsPerPage: 5, currentPage: paginaAtual}"
                    (click)="selecionarCliente(cliente)">
                    <td>{{cliente.vc_nome}}</td>
                </tr>
            </tbody>
        </table>
        <pagination-controls class="pagination d-flex flex-row-reverse" (pageChange)="paginaAtual = $event"
            previousLabel="Anterior" nextLabel="Próximo"></pagination-controls>
    </div>
</div>
<div class="row">
    <div class="col">
        <h3>Clientes selecionados</h3>
        <ul style="max-height: 22vh; overflow: auto;">
            <li class="hover" *ngFor="let clienteSelecionado of clientesSelecionado; let i = index"
                (click)="removerCliente(i)">
                <span
                    [ngClass]="{'text-remover':clientesDiferentes.includes(clienteSelecionado.sr_id) }">{{clienteSelecionado.vc_nome}}</span>
                <mat-icon class="material-icons-sharp del">
                    delete_forever
                </mat-icon>
                <ng-container *ngIf="clientesDiferentes.includes(clienteSelecionado.sr_id)">
                    <span>Existem usuários sem acesso a esse cliente. Cliente será removido.</span>
                </ng-container>
            </li>
        </ul>
    </div>
</div>
<div class="mt-auto p-2 bd-highlight d-flex flex-row justify-content-between row">
    <button (click)="cancel()" class="btn-cancelar btn btn-lg btn-danger" type="btn">Cancelar</button>
    <button class="btn-sucesso btn btn-lg btn-success" (click)="enviarClientesSelecionados()"
        [disabled]="validaConfirmar()">Confirmar</button>
</div>